// src/services/billingApi.ts — Billing & Payments related API endpoints
import { apiClient } from './apiClient';
import type { PricingPlan, PaymentMethod, RazorpayOrder, UsageDashboard } from '../types';

export const billingApi = {
    // PRICING
    getPricingPlans: (): Promise<PricingPlan[]> => apiClient.get('/pricing/plans'),
    getServiceUsage: (serviceId: string | number): Promise<any> => apiClient.get(`/pricing/services/${serviceId}/usage`),
    getTrialStatus: (serviceId: string | number): Promise<any> => apiClient.get(`/pricing/services/${serviceId}/trial-status`),

    // PAYMENTS
    createRazorpayOrder: (data: { amount: number, serviceId?: string | number, billingType: string }): Promise<RazorpayOrder> => apiClient.post('/payment/create-order', data),
    verifyPayment: (data: unknown): Promise<{ success: boolean }> => apiClient.post('/payment/verify-payment', data),
    getPaymentMethods: (): Promise<PaymentMethod[]> => apiClient.get('/payment/methods'),
    getAccountBalance: (): Promise<{ balance: number; pendingCharges: number; transactions: any[] }> => apiClient.get('/payment/balance'),
    setupPaymentMethod: (data: { method_type: string; provider: string; details: any }): Promise<{ success: boolean }> => apiClient.post('/payment/methods/setup', data),
    setDefaultPaymentMethod: (id: number): Promise<{ success: boolean }> => apiClient.post(`/payment/methods/${id}/default`),
    deletePaymentMethod: (id: number): Promise<{ success: boolean }> => apiClient.del(`/payment/methods/${id}`),
    activateServiceBilling: (serviceId: string | number): Promise<{ success: boolean }> => apiClient.post(`/payment/services/${serviceId}/activate`),

    // USAGE
    getUsageDashboard: (): Promise<UsageDashboard> => apiClient.get('/usage/dashboard'),
    upgradePlan: (serviceId: string | number, plan: string): Promise<{ message: string }> => apiClient.post(`/usage/services/${serviceId}/upgrade`, { plan }),

    // BUDGET SETTINGS
    getBudgetSettings: (): Promise<any> => apiClient.get('/billing/budget-settings'),
    updateBudgetSettings: (data: { budgetLimit: number | string | null, autoPause: boolean }): Promise<any> => apiClient.put('/billing/budget-settings', data),

    // RATE LIMITS
    getRateLimitStatus: (): Promise<{ limits: any[] }> => apiClient.get('/rate-limits/status'),

    // BUILD QUEUE
    getBuildQueueStatus: (): Promise<any> => apiClient.get('/builds/queue/status'),
    getUserBuilds: (): Promise<{ builds: any[] }> => apiClient.get('/builds/queue/my-builds'),
};
